<template>
  <div>
    <ProgressBar v-if="!isReservation" />
    <div class="max-w-7xl mx-auto pb-12 pt-8 px-4 sm:px-6 lg:px-8 sm:py-12">
      <ProcessingModal/>
      <div class="max-w-3xl mx-auto">
        <div v-if="isReservation">
          <ReservationInfo/>
        </div>

        <div v-if="isReservation" id="beginnform" class="scroll-m-20"></div>
        <Headline title="Lassen Sie uns starten!" alignment="text-left"/>

        <form @submit="onSubmit">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <Subheadline subheadline="Wer sind Sie? (Mieter)"
                           :showInfo="!isReservation"
                           helptext-headline="Warum benötigen wir Ihre E-Mail-Adresse?"
                           helptext="Um Ihnen Ihr individuelles Angebot zukommen zu lassen, benötigen wir Ihre E-Mail-Adresse. Nach Absenden des Formulars erhalten Sie unser maßgeschneidertes Angebot direkt in Ihr Postfach. Außerdem haben Sie die Möglichkeit, den Online-Antrag mithilfe des Links aus der E-Mail zu einem späteren Zeitpunkt fortzusetzen und das Angebot damit anzunehmen."
              />
              <Gender/>
              <InputLabeled id="start_firstName" label="Vorname" placeholder="Max"/>
              <InputLabeled id="start_lastName" label="Nachname" placeholder="Mustermann"/>
              <DatePicker id="start_birthdate" label="Geburtstag" cols="sm:col-span-2" placeholder="15.01.1980"/>
              <InputLabeled id="start_email" label="E-Mail Adresse" cols="sm:col-span-4" placeholder="max.mustermann@gmail.com"/>
              <Subheadline subheadline="Wie können wir Sie bei Problemen erreichen?"
                           helptext-headline="Angaben zur Telefonnummer:"
                           helptext="Durch Angabe der Telefonnummer können wir Ihnen in dringenden Fällen schneller und effizienter helfen."/>
              <InputLabeled id="start_phone" label="Telefonnummer (optional)" cols="sm:col-span-6" placeholder="0152 01234567"/>
              <Subheadline subheadline="Wo sind Sie aktuell gemeldet (Meldeadresse)?"
                           helptext-headline="Meldeadresse"
                           helptext="Tragen Sie hier die Adresse ein, unter der Sie sich beim Bürgeramt angemeldet haben. Diese entspricht der Adresse auf der Rückseite Ihres Personalausweises. Bei der Eingabe Ihrer Straße werden Ihnen unterhalb des Eingabefelds bereits Vorschläge angezeigt. Dies soll Ihnen das Ausfüllen der Adressfelder erleichtern. Sie können aus der Ergebnisliste Ihre Adresse auswählen. Im Anschluss vervollständigen sich die restlichen Adressfelder automatisch. Prüfen und ergänzen Sie gegebenenfalls die Daten im Formular. Selbstverständlich können Sie Ihre Daten auch manuell in die Felder eingeben. Sie haben Fragen zur Vervollständigung des Adressformulars? Dann wenden Sie sich gerne an unseren Kundenservice unter der Rufnummer 0211 - 54 26 83 00."/>
              <Address addressType="tenant"/>
              <div class="sm:col-span-6" v-if="isReservation">
                <Subheadline
                    id="deposit"
                    @click="openOptionalFields()"
                    class="cursor-pointer"
                    subheadline="Optional: Ihr Beitrag, wenn Sie die Reservierung in eine aktive Bürgschaft umwandeln"
                    helptext-headline="Höhe der Kaltmiete & Kautionssumme"
                    :helptext="'Wenn Sie erfahren möchten, welchen Beitrag Sie bei einer Umwandlung der kostenlosen Reservierung in eine aktive Bürgschaft zahlen würden, geben Sie hier optional die Kaltmiete und die Kautionssumme der Wohnung an. Laut Gesetz darf die Mietkaution nicht höher als das 3-fache der Kaltmiete betragen. Die Höhe des Beitrages liegt bei ' + tenant.priceRateString + ' der Kautionssumme. Sollten Sie die Kaltmiete und/oder die Kautionssumme noch nicht kennen, dann lassen Sie die Felder einfach leer. Dies hat keine Auswirkungen auf die kostenlose Reservierung.'"
                />
                <i class="far fa-chevron-down text-green-400 cursor-pointer block text-center text-2xl font-extrabold rounded-md mt-2"
                   :class="{' fa-rotate-180 mb-3': isOpen}"
                   @click="openOptionalFields()"
                ></i>
                <Deposit v-if="isOpen"/>
              </div>

            </div>
            <Agb/>
            <div class="pt-5">
              <div class="flex justify-end">
                <button type="submit"
                        :disabled = isDisabled
                        :class="[isDisabled ? 'bg-green-300 cursor-auto' : 'bg-green-400 hover:bg-green-300']"
                        class="flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-3xl shadow-sm text-white sm:px-8 w-full sm:w-auto">
                  Weiter
                </button>
              </div>
              <div class="flex justify-center pt-2 sm:justify-end">
                <img class="h-6 w-auto sm:h-6 px-2" src="/images/ssl-logo.png" alt="">
                <div class="pt-1 text-xs">SSL-verschlüsselte Datenübertragung</div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <AdvantagesList/>
    <Contact/>
    <TrustSection/>
    <ModalUserExists/>
  </div>
</template>

<script setup>

import {nextTick, onMounted, ref} from "vue";
import Subheadline from "../components/Subheadline.vue";
import InputLabeled from "../components/InputLabeled.vue";
import Gender from "../components/Gender.vue";
import Agb from "../components/Agb.vue";
import DatePicker from "../components/DatePicker.vue";
import {useTenantStore} from "../stores/tenant";
import AdvantagesList from "../components/AdvantagesList.vue";
import Contact from "../components/Contact.vue";
import TrustSection from "../components/TrustSection.vue";
import Headline from "../../common/components/Headline.vue";
import ReservationInfo from "../components/ReservationInfo.vue";
import Deposit from "../components/Deposit.vue";
import ModalUserExists from "./ModalUserExists.vue";
import ProgressBar from "../components/ProgressBar.vue"; //php Storm is wrong her ProgressBar is used
import {useProgressBarStore} from "../stores/progress-bar";
import ProcessingModal from "../components/Processing.vue";
import Address from "../components/Address.vue";
import { useRoute } from 'vue-router';

const route = useRoute();
const props = defineProps({
  id: String,
})

const progressBar = useProgressBarStore();
const tenant = useTenantStore();
const isOpen = ref(false);
const isDisabled = ref(false);
const isReservation = route.path === '/app/start-reservierung';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
function openOptionalFields() {
  if (isOpen.value) { //delete values if optional fields are closed
    tenant.setFormValue('next_depositAmount', '');
    tenant.setFormValue('next_rentAmount', '');
  }
  isOpen.value = !isOpen.value;
}

onMounted(async () => {
  await tenant.loadUserData(props.id); // Lade Benutzerdaten aus dem Backend get /api/submit-applications/{hashId}
  // toDo: createRedirectUrl is not needed anymore
  tenant.isReservation = tenant.getIsReservation;
  tenant.navigate();
  // Vorausfüllen der Benutzerdaten 
  tenant.prefillUserData();
  
  // Warte bis Vue die DOM-Updates durchgeführt hat,
  // damit vee-validate die aktualisierten Werte erkennen kann
  //@toDo: kann nextTick() entfernt werden?
  await nextTick();

  //await tenant.validateSection('start');
  tenant.scrollToError();

  progressBar.setStepsState('start');
});

// on Reservation is optional to fill in the deposit, if field is empty, the user can continue if validation error submit should not be possible
function checkOptionalReservationFieldsAreValid() {
  // Immediately return true if it's not a reservation
  if (!isReservation) return true;

  if(!tenant.formValues.next_depositAmount && !tenant.formValues.next_rentAmount) {
    return true;
  }
  tenant.validateField('next_depositAmount', tenant.formValues.next_depositAmount);
  tenant.validateField('next_rentAmount', tenant.formValues.next_rentAmount);

  // Check if either next_depositAmount or next_rentAmount errors exist

  const errorKeys = Object.keys(tenant.errors);
  const hasSpecificErrors = errorKeys.some(key =>
      (key === 'next_depositAmount' || key === 'next_rentAmount') && tenant.errors[key]
  );

  // Return false if any of the specific errors exist, true otherwise
  return !hasSpecificErrors;
}
function handleUnexpectedError(error, hashId) {

  window.location.href = `/error?id=${hashId}`;
}
async function onSubmit(event) {
  event.preventDefault(); // Verhindern, dass das Formular standardmäßig gesendet wird
  tenant.setProcessingStartState(tenant.state); // save current state to not redirect without a change in state
  isDisabled.value = true;
  tenant.setProcessingModalOpen(true);

  // check if optional fields are valid
  if(!checkOptionalReservationFieldsAreValid()) {
    isDisabled.value = false;
    tenant.setProcessingModalOpen(false);
    isOpen.value = true;
    document.getElementById('deposit').scrollIntoView({ behavior: 'smooth', block: 'center' })
    return;
  }

  // check if all other fields are valid
  const isValid = await tenant.validateSection('start'); // Validiere das gesamte Formular erneut

  if(!isValid) {
    isDisabled.value = false;
    tenant.setProcessingModalOpen(false);
    tenant.scrollToError();
    return;
  }

  try {
    tenant.setProcessingShowSpinnerOne(true);
    await tenant.postStartData();
  } catch (error) {
    const statusCode = error?.response?.status || null;
    const validationErrors = error?.response?.data?.violations;

    switch(statusCode) {
      case 401: // Unauthorized
      case 403: // Forbidden
      case 404: // Not Found
      case 500: // Internal Server Error
        handleUnexpectedError(error, tenant.hashId);
        return;
      case 400: // Bad Request
      case 422: // Unprocessable Entity
        if (validationErrors?.length > 0) {
          const errors = tenant.handleBackEndValidations(validationErrors, 'start_')
          tenant.errors = {...tenant.errors, ...errors};
          if (errors.start_requestedState) {
            handleUnexpectedError(error, tenant.hashId);
          }
          isDisabled.value = false;
          tenant.resetProcessing();
          tenant.scrollToError();
          return;
        } else {
          handleUnexpectedError(error, tenant.hashId);
          return;
        }
      default:
        handleUnexpectedError(error, tenant.hashId);
        return;
    }
  }
  await sleep(3000)
  // Step 2. Send GET to get state 
  tenant.setProcessingShowSpinnerTwo(true);
  await sleep(3000)
  await tenant.loadUserData();

  // Step 3. redirect to next page
  tenant.setProcessingShowSpinnerThree(true);
  await sleep(1000)
  await tenant.handlePendingState(); // Redirect to next page
};

</script>